module.exports = __webpack_public_path__ + "static/media/medium-lg-4.269c71f6.jpg";